export default __webpack_public_path__ + "static/cube-map-468c3c29e9dd611ae0e0972fb19317c9.png";